/* globals $$,$H,Template,$ */

module.exports = {

  id: 'plusone',
  name: 'google',

  getWidgetHtml: function( googleObj ) {
    this.validate( googleObj );
    return this.googleTemplate().evaluate(this.getGoogleLayoutObj(googleObj));
  },

  getScript: function() {
    return "<script type=\"text/javascript\"> \n (function() {\n" +
        "var po = document.createElement('script'); po.type = 'text/javascript'; po.async = true;\n" +
        "po.src = 'https://apis.google.com/js/plusone.js';\n" +
        "var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(po, s);\n" +
      "})();\n</script>";
  },

  cleanup: function() {
    var jsNode = $( this.id );
    var jsNodes = $$("script[src*='"+this.id+"']");
    if( jsNode ) {
      jsNode.remove();
    }

    if(jsNodes) {
      jsNodes.each(function(el){
        el.remove();
      });
    }
  },

  getStyle: function() {
    return '';
  },

  getSizeByLayout: function(layout) {
    var size = {
      top: {
        width: 51,
        height: 60
      },
      right: {
        width: 64,
        height: 20
      },
      none: {
        width: 33,
        height: 21
      }
    };
    return size[ layout.countOrientation ];
  },

  validate: function( googleObj  ) {
    this.validateKeys( googleObj );
  },

  validateKeys: function( googleObj ) {
    var keys         = $H( googleObj ).keys(),
        requiredKeys = [ 'orientation', 'countOrientation', 'name' ];

    requiredKeys.each( function( key ) {
      if( !keys.include( key ) ) {
        throw key + ': Key is missing form social_widget_google.js';
      }
    } );
  },

  googleTemplate: function() {
    return new Template('<div style="#{styleOverride}"><div class="g-plusone" data-annotation="#{annotation}" data-size="#{size}" data-href="#{url}"></div></div>');
  },

  getGoogleLayoutObj: function( googleObj ) {
    googleObj = $H( googleObj );
    switch( googleObj.get( 'countOrientation' ) ) {
      case 'top':
        googleObj.set( 'size', 'tall' );
        googleObj.set( 'annotation', 'bubble' );
        break;
      case 'right':
        googleObj.set( 'size', 'medium' );
        googleObj.set( 'annotation', 'bubble' );
        googleObj.set( 'styleOverride', 'width: 63px' );
        break;
      default:
        googleObj.set( 'size', 'medium' );
        googleObj.set( 'annotation', 'none' );
    }
    return googleObj;
  }

};



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/modules/lp-social-widget/social_widget_google.js
// module id = 592
// module chunks = 0 1